module.exports = __webpack_public_path__ + "KaTeX_Size2-Regular.63030204.woff2";